<template>
  <div class="compressed-content">
    <h3>What is your waist measurement in inches at your hip bone<br />(this is not your pants size).</h3> 
    <b-img-lazy src="/png/waist-circumference.png" alt="waist circumference" fluid></b-img-lazy>
    <v-form-group class="page-buttons mt-4" :validator="$v.waist" label="Waist size">
      <b-form-input slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="survey.waist"
                    placeholder="Waist size"
                    @click="e => e.target.setSelectionRange(0, e.target.value.length)" />
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between } from "vuelidate/lib/validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import productType from 'enums/product-type';

  export default {
    mixins: [formMixin],

    data() {
      return {
        productType
      }
    },

    validations: {
      waist: {
        required,
        between: between(10, 70)
      }
    },

    computed: {
      ...mapState(["survey"]),

      waist() { return this.survey.waist; },
    }
  };
</script>